export default {
    tableNames: [
        {
            prop: "id",
            name: "ID",
            fixed: "left"
        },
        {
            prop: "keyword",
            name: "关键词"
        },
        {
            prop: "msgType",
            name: "消息类型"
        },
        {
            prop: "content",
            name: "回复内容"
        },
        {
            prop: "mediaId",
            name: "素材ID"
        },
        {
            prop: "eventKey",
            name: "事件Key"
        },
        {
            prop: "createTime",
            name: "创建时间"
        },
        {
            prop: "isEnable",
            name: "是否启用"
        }]
}